module.exports = __webpack_public_path__ + "img/icon_12.e8a3fd10.png";